<template>
  <div class="mypage-user-complete-page">
    <sub-header-section
      :pageTitle="$tc('MypagePage.MypageUserCompletePage.pageTitle')"
      backLink="/mypage"
    />

    <mypage-user-complete-pane class="mypage-user-complete-page__content" />

    <action-buttons-section
      scrollTargetSelector=".mypage-user-complete-page__content"
      :visible="true"
    >
      <atom-router-button
        to="/mypage"
        :linkText="$tc('MypagePage.MypageUserCompletePage.backMyPage')"
        colorType="secondary"
      />
    </action-buttons-section>

    <global-navigation-pane current="mypage" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'
import MypageUserCompletePane from '@/components/MypageUserCompletePage/MypageUserCompletePane.vue'
import ActionButtonsSection from '@/components/common/form/ActionButtonsSection.vue'
import AtomRouterButton from '@/components/atoms/AtomRouterButton.vue'

/**
 * マイページ: 会員情報変更完了ページ
 */
export default defineComponent({
  name: 'MypageUserCompletePage',
  components: {
    SubHeaderSection,
    GlobalNavigationPane,
    MypageUserCompletePane,
    ActionButtonsSection,
    AtomRouterButton,
  },
})
</script>
